const initalState = {};
export default function reducer(state = initalState) {
  return state;
}
